import React from 'react';
import { ControlLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';

import './FormLabel.css';

export default function FormLabel(props) {
    const requiredText = (props.required) ? <span className="form-label-required">*</span> : null;
    let helpText = null;
    let subText = null;

    if (props.helpText) {
        let overlay = <Tooltip id="toolTip">{props.helpText}</Tooltip>;
        helpText = (
            <OverlayTrigger placement="top" overlay={overlay}>
                <i className="fa fa-question-circle form-label-tip-margin"></i>
            </OverlayTrigger>
        );
    }

    if (props.labelSubText) {
        subText =  <small style={{ color: '#898989' }}>{props.labelSubText}</small>;
    }

    const controlProps = {
        bsClass: (props.hasError) ? 'form-label-error' : null
    };

    return (
        <ControlLabel {...controlProps}>{props.children}{requiredText}{helpText} {subText}</ControlLabel>
    );
}
